import Icon from "../components/common/Icon";
import Dashboard from "../components/common/dashboard/Dashboard";
import useDeceased from "../hooks/useDeceased";
import Header from "../components/common/Header";

export default function LomacoImport() {
    const { lomacoData } = useDeceased();

    const dataList = lomacoData?.importList;

    return (
        <main>
            <Header location="Lomaco Import" parent="" />
            <Icon source="fa fa-download" color="blue" span="Liste des défunts"/>
            <div>
                { lomacoData &&
                    <>
                        <h1>Import Défunts - {lomacoData?.userLastName} {lomacoData?.userFirstName}</h1>
                        <br/>
                        <h2>{lomacoData?.agencyName} - {lomacoData?.agencyCity}</h2>
                        <br/>
                        <div className="dashboard">
                            <h3>Import de {lomacoData?.fromApi}</h3>
                            <table>
                                <thead className="dashboard-header">
                                <tr>
                                    <th>Nom et prénom</th>
                                    <th>Date de naissance</th>
                                    <th>Décès</th>
                                </tr>
                                </thead>
                                <tbody>
                                { (dataList?.length > 0) ? dataList.map(singleData => (
                                        <tr>
                                            <td>{singleData.name}</td>
                                            <td>{singleData.birthDate}</td>
                                            <td>{singleData.deathDate}</td>
                                        </tr> )) :
                                    <tr>
                                        <td colSpan="9">Pas d'utilisateur pour cette agence.</td>
                                    </tr>
                                }

                                </tbody>
                            </table>
                        </div>
                    </>
                }

            </div>
        </main>
    )
}